module.exports = __webpack_public_path__ + "img/case_banner.66531bd5.jpg";